import React from "react";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <section>
    
      <ul style={{ listStyle: "none", padding: 0, lineHeight: 1.8 }}>
        <li>
          <Link className="App-link" to="/feature1">
            /feature1
          </Link>
          <span> Basic heart.</span>
        </li>
        <li>
          <Link className="App-link" to="/feature2">
            /feature2
          </Link>
          <span> Updated featured card.</span>
        </li>
        <li>
          <Link className="App-link" to="/feature3">
            /feature3
          </Link>
          <span> Updated featured card with heart.</span>
        </li>
        <li>
          <Link className="App-link" to="/feature4">
            /feature4
          </Link>
          <span> Flowing text colors.</span>
        </li>
        <li>
          <Link className="App-link" to="/feature5">
            /feature5
          </Link>
          <span> Idea pending.</span>
        </li>
                <li>
          <Link className="App-link" to="/feature6">
            /feature6
          </Link>
          <span> Idea pending.</span>
        </li>
                <li>
          <Link className="App-link" to="/feature7">
            /feature7
          </Link>
          <span> Idea pending.</span>
        </li>
                <li>
          <Link className="App-link" to="/feature8">
            /feature8
          </Link>
          <span> Idea pending.</span>
        </li>
      </ul>
    </section>
  );
}
